import AppBar from "@mui/material/AppBar";
import IconButton from "@mui/material/IconButton";
import Typography from "@mui/material/Typography";
import MenuIcon from '@mui/icons-material/Menu';
import Toolbar from "@mui/material/Toolbar";
import { MutableState } from "../_/utils/MutableState";
import { Breadcrumbs } from "@mui/material";
import { Dictionary } from "../_/utils/Dictionary";

type Props = {
    link: string | null,
    openMenu: MutableState<boolean>;
}

export const Bar = ({ link, openMenu }: Props) => {

    return (
        <AppBar position="static">
            <Toolbar>
                <IconButton
                    size="large"
                    edge="start"
                    color="inherit"
                    aria-label="menu"
                    sx={{ mr: 2 }}
                    onClick={openMenu.setState(true)}
                >
                    <MenuIcon />
                </IconButton>
                <Breadcrumbs aria-label="breadcrumb" separator="">
                    <Typography variant="h4" component="div" sx={{ flexGrow: 1 }}>
                        F©US
                    </Typography>
                    {link &&
                        <Typography variant="h5" component="div" sx={{ flexGrow: 1 }}>
                            {link}
                        </Typography>
                    }
                </Breadcrumbs>

            </Toolbar>
        </AppBar>
    )
};



